import { render } from "./HematFishResultFileEdit.vue?vue&type=template&id=672a2207&scoped=true"
import script from "./HematFishResultFileEdit.vue?vue&type=script&lang=js"
export * from "./HematFishResultFileEdit.vue?vue&type=script&lang=js"

import "./HematFishResultFileEdit.vue?vue&type=style&index=0&id=672a2207&lang=scss&scoped=true"
import "./HematFishResultFileEdit.vue?vue&type=style&index=1&id=672a2207&lang=scss"
import "./HematFishResultFileEdit.vue?vue&type=style&index=2&id=672a2207&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672a2207"]])

export default __exports__